import { t, type TranslationKey } from './index.js';
import type { ErrorCode, ErrorParams } from '../engine/reducer.js';

const ID_PARAMS_TO_TRANSLATE: Readonly<Record<string, string>> = Object.freeze({
  location: 'location.',
  job: 'job.',
});

export function translateError(code: ErrorCode, params?: ErrorParams): string {
  let translated: Record<string, string | number> | undefined;
  if (params) {
    translated = {};
    for (const [k, v] of Object.entries(params)) {
      const prefix = ID_PARAMS_TO_TRANSLATE[k];
      if (prefix && typeof v === 'string') {
        translated[k] = t(`${prefix}${v}` as TranslationKey);
      } else {
        translated[k] = v;
      }
    }
  }
  return t(`error.${code}` as TranslationKey, translated);
}
